import "./styles/main.css";
import { SimulationApp } from "./simulation-app";

document.addEventListener("DOMContentLoaded", () => {
  new SimulationApp();
});
